// ============================================================
// Select
// ------------------------------------------------------------
// dropdown ที่พิมพ์ค้นหาได้ (เขียนเอง ใช้แทน react-select ในหน้าที่ต้องการหน้าตาแบบนี้)
//
// props
//   options   : [{ value, label, front? }] — front = ไอคอน/ข้อความเล็กหน้า label
//   value     : ค่าที่เลือกอยู่
//   onChange  : (value, option) => {}  — กด "-- กรุณาเลือก --" จะได้ ("", {value:"",label:""})
//   default   : false = ซ่อนตัวเลือก "-- กรุณาเลือก --"
//   placeholder / className / disabled
// ============================================================

import React, { Component } from "react";

// ความสูงมาตรฐานของช่อง select ให้เท่ากับ input ปกติของระบบ
const select_height = 44;

// style สำหรับ react-select (หน้าที่ยังใช้ react-select อยู่ import ตัวนี้ไปใช้)
export const select_style = {
  control: (baseStyles) => ({
    ...baseStyles,
    height: select_height,
    minHeight: select_height,
    padding: 0,
    border: 0,
    backgroundColor: "#00000000",
    boxShadow: "none",
  }),
  valueContainer: (baseStyles) => ({
    ...baseStyles,
    height: select_height,
    paddingTop: 0,
    paddingLeft: 12,
    paddingBottom: 0,
  }),
  input: (baseStyles) => ({
    ...baseStyles,
    height: select_height,
    minHeight: select_height,
    padding: 0,
    margin: 0,
  }),
};

// style ของรายการตัวเลือกแต่ละแถว (แถวที่ hover อยู่จะเป็นสีเทา)
const optionStyle = (isHover) => ({
  display: "flex",
  width: "100%",
  cursor: "pointer",
  padding: 4,
  backgroundColor: isHover ? "#dfdfdf" : "#fff0",
  color: "#000000",
});

export default class Select extends Component {
  state = {
    showSelectOption: false, // เปิดรายการตัวเลือกอยู่ไหม
    search: "", // ข้อความที่พิมพ์ค้นหา
    selected: "", // ตัวเลือกที่เมาส์ชี้อยู่ (ใช้ทำ hover)
  };

  // ตัวเลือกที่ตรงกับคำค้น (ไม่พิมพ์อะไร = แสดงทั้งหมด)
  filteredOptions = () => this.props.options?.filter((e) => !this.state.search || e.label.includes(this.state.search)) || [];

  // option ที่ถูกเลือกอยู่ตอนนี้
  currentOption = () => this.props.options?.find((e) => e.value === this.props.value);

  // ปิดรายการแล้วส่งค่ากลับหน้าจอแม่
  pick = (value, option) => {
    this.setState({ showSelectOption: false, search: "", selected: "" });
    this.props.onChange(value, option);
  };

  render() {
    const { showSelectOption, search, selected } = this.state;
    const options = this.filteredOptions();
    const current = this.currentOption();
    // ไอคอนหน้า label จะโชว์เฉพาะตอนไม่ได้พิมพ์ค้นหาและไม่ได้เปิดรายการ
    const showFront = !search && !showSelectOption && current?.front;

    return (
      <div style={{ position: "relative", padding: 0 }} className={this.props.className}>
        {/* ฉากหลังโปร่งใส กดแล้วปิดรายการ */}
        {showSelectOption && (
          <div style={{ bottom: 0, left: 0, top: 0, right: 0, backgroundColor: "#0000", zIndex: 1000, position: "fixed" }} onClick={() => this.setState({ showSelectOption: false })}></div>
        )}

        <div style={{ position: "relative" }}>
          {showFront ? <div className="position-absolute mx-2 mt-1">{current.front}</div> : null}

          {/* ช่องกรอก: แสดง label ของค่าที่เลือก จนกว่าจะเริ่มพิมพ์ค้นหา */}
          <input
            className={this.props.className?.replaceAll("mb-2", "").replaceAll("mb-3", "").replaceAll("mb-4", "").replaceAll("mb-5", "")}
            style={{
              width: "100%",
              backgroundColor: this.props.disabled ? "#e9ecef" : "#00000000",
              border: 0,
              paddingLeft: showFront ? 36 : ".75rem",
            }}
            type="text"
            value={!search && !showSelectOption && this.props.value ? current?.label : search}
            placeholder={this.props.placeholder || ""}
            onFocus={() => this.setState({ showSelectOption: true, search: "", selected: "" })}
            onChange={(e) => this.setState({ search: e.target.value })}
            disabled={this.props.disabled}
          />

          {/* ลูกศรชี้ลง (วาดจาก div 2 อันเอียง 45 องศา) */}
          <div style={{ display: "flex", position: "absolute", right: 8, top: "50%" }}>
            <div style={{ width: 7, height: 1.7, backgroundColor: "#232323", transform: "rotate(45deg)", borderRadius: 1 }}></div>
            <div style={{ width: 7, height: 1.7, backgroundColor: "#232323", transform: "rotate(315deg)", marginLeft: -3.2, borderRadius: 1 }}></div>
          </div>
        </div>

        {/* รายการตัวเลือก */}
        {showSelectOption && (
          <div
            id="select-tool"
            style={{ minWidth: 150, width: "100%", padding: 6, borderRadius: 6, borderWidth: 1, borderColor: "#d2d2d2", borderStyle: "solid", backgroundColor: "#fdfdfd", position: "absolute", top: 40, zIndex: 1001 }}
          >
            <div style={{ maxHeight: 400, overflow: "scroll", scrollbarWidth: "none", msOverflowStyle: "none" }}>
              {/* ตัวเลือกล้างค่า — ซ่อนเมื่อไม่มีผลค้นหา หรือหน้าจอสั่ง default={false} */}
              {options.length !== 0 && this.props.default !== false && (
                <div style={{ ...optionStyle(selected === ""), display: "block" }} onClick={() => this.pick("", { value: "", label: "" })} onMouseEnter={() => this.setState({ selected: "" })}>
                  -- กรุณาเลือก --
                </div>
              )}

              {options.map((item, index) => (
                <div key={`array-${index}`} style={optionStyle(selected === item.value)} onClick={() => this.pick(item.value, item)} onMouseEnter={() => this.setState({ selected: item.value })}>
                  {item.front || ""}
                  {item.label}
                </div>
              ))}

              {/* ไม่พบข้อมูลตามคำค้น */}
              {options.length === 0 && (
                <div style={{ maxHeight: 300, overflow: "scroll" }}>
                  <div style={{ width: "100%", textAlign: "center", color: "#2c2c2c" }}>ไม่พบข้อมูล...</div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}
